import { getYear, isSameDay, isValid, parseISO } from "date-fns";

export function isUnauthenticated(error) {
    const status = (error?.response && error?.response?.status) ? error.response.status : null;
    const unauthorizedErrors = ["The user is not authenticated", "No current user", "Request failed with status code 401"];
    
    return unauthorizedErrors.includes(error) || status === 401
}

export function getCurrentURLLocation() {
    let path = "";
    if (window.location.pathname) {
      path = window.location.pathname;
      if (window.location.search) {
        path += window.location.search;
      }
    }
    return path
  }
  

const _concatOrAdd = (styles) => {
    let sx = []
    if(Array.isArray(styles)) {
        sx = sx.concat(styles)
    } else if (styles) {
        sx.push(styles)
    }
    return sx
}

export const mergeSxStyles = (originalStyles, newStyles) => {
    let sx = _concatOrAdd(originalStyles)
    sx = sx.concat(_concatOrAdd(newStyles))
    return sx
}


export const parseOSUID = (user = {}) => {
  return user?.osuid 
    || user?.["custom:osuid"] 
    || user?.["custom:emplid"] 
    || user?.["custom:idmid"]
}

export const capitalize = (str) => {
  if (!str) return '';
  return str.split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const getEasternFormat = (date, options) => {
  if(!date) {
    return ''
  }
  const _date = new Date(date)
  if(!isValid(_date)) {
    return ''
  }
  
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    ...options
  });
  
  return dateFormatter.format(_date)
};


export const getCurrentEasternYear = () => {
  return parseInt(getEasternFormat(new Date(), {
    year: 'numeric'
  }), 10);
};

export const convertFieldToBoolean = (field = '') => {
  const lowerCased = typeof field === 'string' ? field.toLowerCase() : field
  const positive = [
    true,
    "true",
    "y",
    "yes"
  ].some(condition =>lowerCased === condition)
  return positive
};

export const isFormTypeValid = () => {
  // let isValid = Object.values(FORM_TYPES).some(formType => formType.toLowerCase() === type?.toLowerCase())
  return true
}

export function getNestedValue(obj, path, defaultValue = undefined) {
  if (!obj || !path) return defaultValue;
  
  try {
    return path.split('#').reduce((current, key) => {
      if (current === null || current === undefined) {
        return defaultValue;
      }
      return current[key];
    }, obj);
  } catch (error) {
    return defaultValue;
  }
}

export const formatFormTypeByConditional = ({ type, isRestrictedOrConditional }) => {
    if(typeof type !== 'string') {
      return type
    }
    const isROrC = convertFieldToBoolean(isRestrictedOrConditional);
    let label = capitalize(type)
    if (isROrC) {
      label += ` (Restricted)`;
    }
    return label;
  }
export const s3Prefix = "s3://";
export const generateParametersFromDownloadJSONQueryFromS3Url = (url = "") => {
  const [, ...fullPath] = url.replace(s3Prefix, "").split("/");
  return {
    path: fullPath.join("/"),
  };
};

export const formatStartEnd = ({ delimeter = '-', start, end, includeTime }) => {
  if (!start || !end) return '';
  
  const startDate = parseISO(start);
  const endDate = parseISO(end);
  
  if (!isValid(startDate) && !isValid(endDate)) return '-';
  
  const baseOptions = { 
    month: 'long', 
    day: 'numeric'
  };
  if(includeTime) {
    baseOptions.hour = 'numeric'
    baseOptions.minute = '2-digit'
  }
  const yearOptions = { ...baseOptions, year: 'numeric' };
  
  if (!isValid(startDate)) return `TBD ${delimeter} ${getEasternFormat(endDate, yearOptions)}`;
  if (!isValid(endDate)) return `${getEasternFormat(startDate, yearOptions)} ${delimeter} TBD`;
  const sameDay = isSameDay(endDate, startDate)
  
  if (sameDay) {
    if (includeTime) {
      return `${getEasternFormat(startDate, baseOptions)} ${delimeter} ${getEasternFormat(endDate, { ...baseOptions, month: undefined, day: undefined })}, ${getYear(startDate)}`;
    }
    return getEasternFormat(startDate, yearOptions);
  }

  const sameYear = getYear(startDate) === getYear(endDate);
  const startOptions = sameYear ? baseOptions : yearOptions;
  if(sameYear && includeTime) {
    return `${getEasternFormat(startDate, startOptions)} ${delimeter} ${getEasternFormat(endDate,startOptions)}, ${getYear(startDate)}`;
  }
  //March 15 at 10:00 AM - June 20, 2024 at 2:30 PM
  return `${getEasternFormat(startDate, startOptions)} ${delimeter} ${getEasternFormat(endDate,yearOptions)}`;
};


const EMPTY_ARRAY = [];

export const formatDeadlines = (deadlines) => {
  if(!deadlines?.length) {
    return EMPTY_ARRAY
  }
  
  const formatted = deadlines.map(
      ({
        label = "Reporting Period",
        start,
        end,
        formsOpenDate,
        formsCloseDate,
      }) => {
        return {
          label: `${label}: ${formatStartEnd({
            delimeter: "to",
            start,
            end,
          })}`,
          description: `Open for submissions from ${formatStartEnd({
            delimeter: "-",
            start: formsOpenDate,
            end: formsCloseDate,
          })}`,
        };
      }
    );
  return formatted.filter((a) => a?.label && a?.description);
}

export const parseS3Url = (url = '') => {
  let path = '', bucket
    if(url.startsWith("s3://")) {
    const [,, _bucket, ...restPath] = url.split('/');
    path = restPath.join('/')
    bucket = _bucket
  }
  return { path, bucket }
}